import { render, staticRenderFns } from "./BlackFooter.vue?vue&type=template&id=54593dc1&scoped=true&"
import script from "./BlackFooter.vue?vue&type=script&lang=js&"
export * from "./BlackFooter.vue?vue&type=script&lang=js&"
import style0 from "./BlackFooter.vue?vue&type=style&index=0&id=54593dc1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54593dc1",
  null
  
)

export default component.exports